import type { CostSidebarItem, FilterProviderSidebarItemsParams } from '../types';

const filterProviderSidebarItems = ({
    items,
    query,
}: FilterProviderSidebarItemsParams): CostSidebarItem[] => {
    const normalizedQuery = query.trim().toLowerCase();
    if (normalizedQuery.length === 0) {
        return items;
    }
    return items.filter(item => item.label.toLowerCase().includes(normalizedQuery));
};

export default filterProviderSidebarItems;
